import { UserCache } from "../../services";


export class FbxLog {

  
    
    private constructor() {
        // Private constructor to prevent direct instantiation
    }

    private static get enabled() {
            const  debugOptions = UserCache.debugOptions;
        return debugOptions?.logging ?? false;
    }



    public static log(message: string, ...optionalParams: any[]): void {
        if (FbxLog.enabled) {
            console.log(message, ...optionalParams);
        }
    }

     public static error(message: string, ...optionalParams: any[]): void {
        if (FbxLog.enabled) {
            console.error(message, ...optionalParams);
        }
    }
}